"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("homeBookmark", function () {
  return {
    restrict: "E",
    replace: true,
    template: require("./homeBookmark.html"),
    controller: function controller($scope, $http, $applications) {
      function loadBookmarks() {
        $http.get('/rest/home/user-bookmarks').then(function (response) {
          $scope.bookmarks = response.data;
        });
      }
      loadBookmarks();
      $scope.toggleBookmarkEdition = function () {
        $scope.editionBookmarks = !$scope.editionBookmarks;
      };
      $scope.remove = function (bookmark) {
        bookmark.deleting = true;
        $http.delete('/rest/bookmark/delete/' + bookmark.id).then(function (response) {
          loadBookmarks();
        }).finally(function () {
          // on ne retire pas le deleting vu que la liste va etre rechargée, ça évite que cela "clignote"
        });
      };
      $scope.getFullUrl = function (bookmark) {
        return $applications.getApp(bookmark.application || 'DETTE').path + "/" + bookmark.url;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/bookmark/homeBookmark.js
// module id = 2786
// module chunks = 13